<script setup lang="ts">
import type { SerializedOffer } from '@models/offer.ts';
import { computed } from 'vue';
import { type PromoteType } from '@models/promoteType.ts';
import Typography from '@components/Typography.vue';
import { trans } from '@elements/translation.ts';

const props = defineProps<{ offer: SerializedOffer }>();

const promoteType = computed<PromoteType | null>(
  () => (props.offer.promote_types.length ? props.offer.promote_types[0] : null),
);

const isOffmarket = computed<boolean>(() => props.offer.is_offmarket);
</script>

<template>
  <div class="selection-item-tags">
    <Typography
      v-if="promoteType"
      variant="body-small-bold"
      class="selection-item-tags__tag selection-item-tags__tag--promote"
      :class="`selection-item-tags__tag--${promoteType.code}`"
    >
      {{ trans(`offer.promote_type.${promoteType.code}`) }}
    </Typography>

    <Typography
      v-if="isOffmarket"
      class="selection-item-tags__tag selection-item-tags__tag--offmarket"
      variant="body-small-bold"
    >
      {{ trans('offer.label.offmarket') }}
    </Typography>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-tags {
  display: flex;
  gap: rem(4);

  &__tag {
    border-radius: 8px;
    height: rem(28);
    padding: rem(4) rem(8);
    display: flex;
    align-items: center;
    background-color: red;

    &--promote {
      border: 1px solid $colorBlack;
    }

    &--offmarket {
      background-color: $colorYellow;
    }

    &--premium {
      background-color: $colorRedLight;
    }

    &--exclusive {
      background-color: $colorPurpleLight;
    }

    &--good_deal {
      background-color: $colorYellowLight;
    }
  }
}
</style>
